import React, { useMemo } from "react";
import { Text } from "../text/Text";
import { style as iconStyle } from "./Icon.style";
const Icon = ({ name, style: customStyle, testID = "icon", ...props }) => {
    const style = useMemo(() => iconStyle(), []);
    return (React.createElement(Text, { ...props, accessibilityElementsHidden: true, allowFontScaling: false, importantForAccessibility: "no", selectable: false, style: [style.icon, customStyle], testID: testID }, String.fromCharCode(style.iconGlyphs[name])));
};
export { Icon };
